var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.editMode)?_c('v-btn',{staticClass:"mr-3",attrs:{"color":"primary","depressed":""},on:{"click":function($event){return _vm.$emit('list-save')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-content-save-all ")]),_c('span',[_vm._v("保存")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }